const faqData = [
  {
    question: "평택 화양 서희스타힐스는 어디에 들어서나요?",
    answer: `
평택 화양 서희스타힐스는 경기도 평택시 현덕면 화양리 화양지구 7-2BL에 공급되는 브랜드 아파트입니다.<br/><br/>

사업지는 평택 화양지구 도시개발사업 핵심 생활권에 위치하며 서평택을 대표하는 신도시 생활 인프라를 함께 누릴 수 있는 입지입니다.<br/><br/>

평택항과 평택BIX, 현덕지구, 포승국가산업단지와 가까워 직주근접과 미래가치를 동시에 기대할 수 있는 주거단지입니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스는 몇 세대 규모인가요?",
    answer: `
평택 화양 서희스타힐스는 총 1,554세대 규모의 브랜드 대단지 아파트로 공급됩니다.<br/><br/>

단지는 지하 2층부터 지상 최고 29층 규모로 조성되며 화양지구를 대표하는 랜드마크 단지로 계획되어 있습니다.<br/><br/>

대단지 프리미엄과 다양한 커뮤니티 시설, 브랜드 특화설계를 함께 누릴 수 있는 것이 특징입니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스는 어떤 타입이 있나요?",
    answer: `
평택 화양 서희스타힐스는 실수요 선호도가 높은 전용 59㎡와 84㎡ 타입으로 구성됩니다.<br/><br/>

전용 59㎡와 84㎡ 중심의 다양한 평면을 통해 신혼부부부터 4인 가족까지 폭넓은 수요층을 고려하였습니다.<br/><br/>

4Bay 중심 설계와 효율적인 공간 활용으로 실거주 만족도를 높인 브랜드 평면이 적용됩니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스의 교통환경은 어떤가요?",
    answer: `
평택 화양 서희스타힐스는 서해안고속도로와 38번 국도 이용이 편리하며 안중역(서해선 복선전철 예정)을 통한 광역 교통망을 기대할 수 있습니다.<br/><br/>

향후 평택선과 KTX 직결 계획, 서부내륙고속도로 등 다양한 교통 개발호재가 예정되어 있어 수도권 접근성이 더욱 향상될 전망입니다.<br/><br/>

평택항과 산업단지 출퇴근도 편리한 직주근접 입지를 갖추고 있습니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스의 생활인프라는 어떤가요?",
    answer: `
평택 화양 서희스타힐스는 화양지구 중심상업시설과 공공청사, 종합병원 예정부지 등 풍부한 생활 인프라를 가까이 이용할 수 있습니다.<br/><br/>

현화지구와 안중 생활권을 함께 누릴 수 있으며 다양한 쇼핑·문화·의료시설 이용이 가능한 것이 장점입니다.<br/><br/>

화양지구 개발 완료 이후 더욱 풍부한 생활환경을 기대할 수 있습니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스의 교육환경은 어떤가요?",
    answer: `
평택 화양 서희스타힐스는 단지 인근 초등학교와 중학교 예정부지, 교육시설이 계획된 학세권 입지를 갖추고 있습니다.<br/><br/>

도보 통학이 가능한 교육환경과 함께 화양지구 교육 인프라를 이용할 수 있어 자녀를 둔 실수요자들의 관심이 높습니다.<br/><br/>

안전한 교육환경과 신도시 프리미엄을 함께 기대할 수 있는 입지입니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스 모델하우스는 어떻게 방문하나요?",
    answer: `
평택 화양 서희스타힐스 모델하우스는 홈페이지 또는 대표번호를 통해 사전 방문예약 후 관람하는 것을 권장합니다.<br/><br/>

방문 시 평면구성, 분양가, 청약 일정, 계약조건, 잔여세대 현황 등 다양한 상담을 받아볼 수 있습니다.<br/><br/>

보다 원활한 상담을 위해 사전 예약 후 방문하는 것이 좋습니다.
`,
  },

  {
    question: "평택 화양 서희스타힐스는 어떤 분들에게 추천되나요?",
    answer: `
평택 화양 서희스타힐스는 평택 화양지구 신도시 생활권을 선호하는 실수요자와 서평택 산업단지 직주근접을 원하는 수요자에게 추천되는 브랜드 아파트입니다.<br/><br/>

총 1,554세대 규모의 대단지와 전용 59㎡·84㎡ 중심의 실거주형 평면, 우수한 교통환경과 생활 인프라를 함께 갖춘 것이 장점입니다.<br/><br/>

평택 화양지구 개발호재와 미래가치를 함께 기대하는 수요자라면 관심 있게 살펴볼 만한 브랜드 아파트입니다.
`,
  },
];

export default faqData;